<template>

  <select :id="_uid" class="ui dropdown" :class="{ fluid, search }" :multiple="multiple">
    <option v-if="!addSelectValue" value="">{{ selectLabel }}</option>
  </select>

</template>

<script>

  let settingDropdownSelected = false

  export default {

    name: "SelectDropdown",

    data() {
      return {
        el: null,
        values: [],
      }
    },

    props: {
      search: { type: Boolean, default: true },
      fluid: { type: Boolean, default: true },
      addSelectValue: { type: Boolean, default: false },
      showValueId: { type: Boolean, default: false },
      multiple: { type: Boolean, default: false },
      selectLabel: { type: String, default: "Selecione..." },
    },

    mounted() {

      this.el = $("#" + this._uid)
      
      this.el.dropdown({
        fullTextSearch: this.search,
        onAdd: (value) => this.$emit("onAdd", value),
        onRemove: (value) => this.$emit("onRemove", value),
        onChange: (value) => this.$emit("onChange", value),
      })
    },

    methods: {

      getElement() {
        return this.el[0]
      },

      setSelected(data) {

        let selectedValue = null

        if (Array.isArray(data)) {

          selectedValue = []

          data.forEach((el) => selectedValue.push(el.toString()))

        } else {

          selectedValue = data
        }        
        
        this.el.dropdown("set selected", selectedValue)
      },

      clear() {
        this.el.dropdown("clear")
        this.el.dropdown("change values", [])
      },

      reset() {
        this.clear()
        this.setValues(this.values)
      },

      setValues(data, setSelectedValue) {

        let values = []

        if (this.addSelectValue)
          values.push({ value: "", label: this.selectLabel, name: this.selectLabel })  

        data.forEach((item) => {

          let value = item.id || item.value || item.code
          let label = item.label || item.description || item.name || item.value

          if (this.showValueId)
            label = value + " - " + label
          
          values.push({ value, label, name: label })
        })

        this.values = values

        this.el.dropdown("clear")
        this.el.dropdown("change values", values)

        if (setSelectedValue) {

          this.setSelected(setSelectedValue)

        } else if (this.addSelectValue) {

          this.setSelected("")
        }  
      },
    },
  }

</script>

